<template>
  <div
    v-set-test-id="['FieldSet', testId]"
    class="text-primary mb-3"
    :class="isSubCategory ? 'text-subtitle-1' : 'text-h6'"
  >
    <slot name="title">{{ title }}</slot>
  </div>
  <slot name="default" />
</template>

<script lang="ts" setup>
import type { ActionableComponentProps } from '@/common/components/ActionableComponent';
import { vSetTestId } from '@/common/components/ActionableComponent';

type Props = ActionableComponentProps & {
  title?: string;
  isSubCategory?: boolean;
};
defineProps<Props>();
</script>
